import { cRegion } from "../config/config";

const path = {
    home: '/',
    userGuide: '/userguide',
    signin: '/auth/signin',
    forgetPassword: '/auth/forget-password',
    resetPassword: '/auth/reset-password',
    calender_auth: '/auth/add-event-to-calender/',
    signout: '/auth/authentication/global-logout',
    signup: '/auth/signup',
    join_meeting: '/join/',
    meeting_list: '/my-meetings',
    meeting_details: '/meeting-details/',
    drawing: '/drawing/',
    error_404: '/404'
};


export const wsUrl = () => ({
        'shadhin': {
            dev_local: () => `http://127.0.0.1:5000`,
            dev: () => `https://coredev.shadhin.ai`,
            qa: () => `https://coreqa.shadhin.ai`,
            stage: () => `https://core.shadhin.ai`,
            alpha: () => `http://corealpha.shadhin.ai`,
        },
    }[process.env.REACT_APP_COMPANY_NAME][process.env.REACT_APP_ENV_MODE || 'dev'])

export const apiUrl = () => ({
        'shadhin': {
            dev_local: "http://localhost:5000/api/",
            dev: process.env.REACT_APP_BASE_URL_DEV,
            qa: process.env.REACT_APP_BASE_URL_QA,
            prod: process.env.REACT_APP_BASE_URL_PROD,
            alpha: `http://corealpha.shadhin.ai/api/`,
        },
    }[process.env.REACT_APP_COMPANY_NAME][process.env.REACT_APP_ENV_MODE || 'dev'])

export const _bucket_ = () => ({
        'shadhin': {
            dev: process.env.REACT_APP_AWS_BUCKET_DEV,
            qa: process.env.REACT_APP_AWS_BUCKET_QA,
            prod: process.env.REACT_APP_AWS_BUCKET_PROD,
            alpha: `shadhin-bot-bot-files-bucket-dev`,
        },
    }[process.env.REACT_APP_COMPANY_NAME][process.env.REACT_APP_ENV_MODE || 'dev'])

export const identityId = () => ({
        'shadhin': {
            dev: process.env.REACT_APP_AWS_IDENTITY_POOL_ID_DEV,
            qa: process.env.REACT_APP_AWS_IDENTITY_POOL_ID_QA,
            prod: process.env.REACT_APP_AWS_IDENTITY_POOL_ID_PROD,
            alpha: "us-east-1:d4047dd3-ad01-4b50-af1d-6256b7f672a7",
        },
    }[process.env.REACT_APP_COMPANY_NAME][process.env.REACT_APP_ENV_MODE || 'dev'])

export const cognitoUserPoolId = () => ({
        'shadhin': {
            dev: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID_DEV,
            qa: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID_QA,
            prod: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID_PROD,
            alpha: "us-east-1_DfJoWPWJO",
        },
    }[process.env.REACT_APP_COMPANY_NAME][process.env.REACT_APP_ENV_MODE || 'dev'])

export const userPoolWebClientId = () => ({
        'shadhin': {
            dev: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID_DEV,
            qa: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID_QA,
            prod: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID_PROD,
        },
    }[process.env.REACT_APP_COMPANY_NAME][process.env.REACT_APP_ENV_MODE || 'dev'])

export const concatBucket = () => ({
        'shadhin': {
            dev: "lms-meetmates-concat-bucket-lms-meetmates-qa",
            qa: "lms-meetmates-concat-bucket-lms-meetmates-qa",
            stage: "lms-meetmates-concat-bucket-lms-meetmates-qa",
        },
    }[process.env.REACT_APP_COMPANY_NAME][process.env.REACT_APP_ENV_MODE || 'dev'])

export const s3BaseUrl = () => `https://${_bucket_()}.s3.${cRegion}.amazonaws.com/public/`




export default path;
